import React from "react";

import { Box, TextField, Button, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface GuestCommentFormProps {
    username: string;
    body: string;
    onCommentChange: (payload: { body: string; username?: string }) => void;
    onSubmit?: () => void;
    disabled?: boolean;
    hasVoted: boolean;
}

const GuestCommentForm: React.FC<GuestCommentFormProps> = ({
    username,
    body,
    onCommentChange,
    onSubmit,
    disabled = false,
    hasVoted,
}) => {
    const { t } = useTranslation();
    const handleAuthorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onCommentChange({ body, username: e.target.value });
    };

    const handleBodyChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        onCommentChange({ body: e.target.value, username });
    };

    const handleFormSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (onSubmit && username && body) {
            onSubmit();
        }
    };

    return (
        <Paper
            elevation={0}
            style={{
                padding: 24,
                width: "100%",
                boxSizing: "border-box",
            }}
        >
            {hasVoted ? (
                <Typography variant="body1" color="textSecondary">
                    {t("guest_comment_form.already_commented")}
                </Typography>
            ) : (
                <form
                    style={{ width: "100%" }}
                    onSubmit={handleFormSubmit}
                    autoComplete="off"
                >
                    <Box mb={2} width="100%">
                        <TextField
                            label={t("guest_comment_form.author_label")}
                            value={username}
                            onChange={handleAuthorChange}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            placeholder={t(
                                "guest_comment_form.author_placeholder"
                            )}
                            required
                            size="small"
                            style={{ marginBottom: 24 }}
                            disabled={disabled}
                        />
                        <TextField
                            label={t("guest_comment_form.comment_label")}
                            value={body}
                            onChange={handleBodyChange}
                            multiline
                            minRows={3}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            placeholder={t(
                                "guest_comment_form.comment_placeholder"
                            )}
                            required
                            size="small"
                            disabled={disabled}
                        />
                    </Box>
                    <Box
                        mt={4}
                        width="100%"
                        display="flex"
                        justifyContent="flex-end"
                    >
                        <Button
                            aria-label={t(
                                "guest_comment_form.submit_aria_label"
                            )}
                            variant="contained"
                            color="primary"
                            style={{ minWidth: 140, fontWeight: 600 }}
                            disabled={!username || !body || disabled}
                            type="submit"
                        >
                            {t("guest_comment_form.submit_button")}
                        </Button>
                    </Box>
                </form>
            )}
        </Paper>
    );
};

export default GuestCommentForm;
